export const STATE_NAME = 'inboxCounter';

export const enum ActionTypes {
  START = '[InboxCounter] START',
  DONE = '[InboxCounter] DONE',
  FAIL = '[InboxCounter] FAIL',
}
